import _assign from 'lodash/assign';
import _isEmpty from 'lodash/isEmpty';
import _pickBy from 'lodash/pickBy';
import _isObject from 'lodash/isObject';
import _isString from 'lodash/isString';
import _isNaN from 'lodash/isNaN';

export const isAbsoluteURL = (url) => /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);

export const combineURLs = (relativeURL, baseURL) =>
  relativeURL ? `${baseURL.replace(/\/+$/, '')}/${relativeURL.replace(/^\/+/, '')}` : baseURL;

export const mergeData = (data, defaultData) => {
  if (!defaultData) {
    return data;
  }

  return _assign({}, defaultData, data);
};

export const pickNonEmpty = (data) =>
  _pickBy(data, (value) => {
    if (value == null) {
      return false;
    }

    if (_isObject(value)) {
      return !_isEmpty(value);
    }

    if (_isString(value)) {
      return value !== '';
    }

    if (_isNaN(value)) {
      return false;
    }

    return true;
  });
